import { RENEWAL_CATEGORY_CONFIG } from 'constants/annotation'
import useDirectory from 'hooks/useDirectory'
import { AnnotationType } from 'types/building'
import { mapAnnotationTypeToCategory } from 'utils/annotationRN'

import AirConditionIcon from 'components/icons/AirConditionIcon'
import DocumentIcon from 'components/icons/DocumentIcon'
import EarthquakeIcon from 'components/icons/EarthquakeIcon'
import EquipmentIcon from 'components/icons/EquipmentIcon'
import FireIcon from 'components/icons/FireIcon'
import FloodIcon from 'components/icons/FloodIcon'
import HouseIcon from 'components/icons/HouseIcon'
import LifelineIcon from 'components/icons/LifelineIcon'
import LightBulbIcon from 'components/icons/LightBulbIcon'
import MemoFileIcon from 'components/icons/MemoFIleIcon'
import TraditionIcon from 'components/icons/TraditionIcon'
import VolcanoIcon from 'components/icons/VolcanoIcon'

type Props = {
  type: AnnotationType | number
  size: 'small' | 'large'
}

export default function FolderIcon({ size, type }: Props) {
  const { isRN } = useDirectory()

  if (isRN) {
    if (type === AnnotationType.DOCUMENT || Number(type) === 41) {
      return <DocumentIcon size={size} />
    }
    if (type === AnnotationType.MEMO || Number(type) === 40) {
      return <MemoFileIcon />
    }

    const catKey = mapAnnotationTypeToCategory(type)
    const conf = RENEWAL_CATEGORY_CONFIG[catKey]

    if (conf) {
      const isLarge = size === 'large'
      const diameter = isLarge ? 32 : 22
      const fontSize = isLarge ? 17 : 12

      return (
        <span
          className="inline-flex items-center justify-center rounded-full text-white shadow-sm flex-shrink-0 select-none"
          style={{
            width: `${diameter}px`,
            height: `${diameter}px`,
            backgroundColor: conf.colorHex,
            fontFamily: "Georgia, 'Times New Roman', serif",
            fontWeight: 900,
            fontSize: `${fontSize}px`,
            lineHeight: 1
          }}
        >
          {catKey}
        </span>
      )
    }
  }

  switch (type) {
    case AnnotationType.ELECTRICITY:
      return <LightBulbIcon size={size} />
    case AnnotationType.AIR_CONDITION:
      return <AirConditionIcon size={size} />
    case AnnotationType.ARCHITECTURE:
      return <HouseIcon size={size} />
    case AnnotationType.EQUIPMENT:
      return <EquipmentIcon />
    case AnnotationType.FIRE:
      return <FireIcon />
    case AnnotationType.EARTHQUAKE:
      return <EarthquakeIcon />
    case AnnotationType.FLOOD:
      return <FloodIcon />
    case AnnotationType.VOLCANO:
      return <VolcanoIcon />
    case AnnotationType.DOCUMENT:
      return <DocumentIcon size={size} />
    case AnnotationType.LIFE_LINE:
      return <LifelineIcon />
    case AnnotationType.MEMO:
      return <MemoFileIcon />
    default:
      return <TraditionIcon />
  }
}
